import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SIDEBAR_NAV_ITEMS } from '../constants/sidebarNavConfig';
import { accessRightSubMenu } from '../utils/functions/accessRight';
import { isBudgetApprover } from '../utils/functions/approverAccess';
import { AccessDenied } from './Error';

// เมนูที่ sidebar ซ่อนตามบทบาทผู้อนุมัติ (ดู MainSidebar.js) — ไม่เอามาเป็นหน้าแรกของโมดูล เพราะ user ทั่วไปเข้าไม่ได้
// (payment-approval/expense-review อยู่ท้ายสุดของโมดูลการเงินอยู่แล้ว จึงข้ามไปเลยดีกว่าเช็คบทบาทซ้ำ)
const ROLE_ONLY_HREFS = ['/profile/payment-approval', '/profile/expense-review'];

// หน้าแรกของโมดูล (เช่น /finance) — redirect ไปเมนูย่อยตัวแรกที่ user มีสิทธิ์ ตามลำดับเดียวกับ sidebar
// ไม่มีเมนูไหนเข้าได้เลยขึ้นหน้า "ไม่มีสิทธิ์เข้าถึง"
export default function ModuleIndexRedirect({ moduleName, moduleLabel }) {
  const me = useSelector((state) => state.me);
  const info = useSelector((state) => state.info);
  const hidden = new Set(info?.setting?.hidden_menus || []);

  const candidates = SIDEBAR_NAV_ITEMS
    .filter((item) => item.name === moduleName)
    .flatMap((item) => (item.sub?.length
      ? item.sub.map((s) => ({ ...s, name: item.name }))
      : [{ href: item.href, level: 0, name: item.name }]));

  const target = candidates.find((c) => (
    !ROLE_ONLY_HREFS.includes(c.href)
    && !(c.href === '/profile/budget-approval' && !isBudgetApprover(me, info))
    && !hidden.has(c.href)
    && accessRightSubMenu(me, c.name, c.href, c.level ?? 0)
  ));

  if (!target) {
    return <AccessDenied moduleLabel={moduleLabel} />;
  }

  return <Redirect to={target.href} />;
}

ModuleIndexRedirect.propTypes = {
  moduleName: PropTypes.string.isRequired,
  moduleLabel: PropTypes.string,
};

ModuleIndexRedirect.defaultProps = {
  moduleLabel: null,
};
